// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"0bf85d9d","461":"f2d46a88","749":"d02a4180","897":"1bd244db","912":"638437e2"}[chunkId] + ".chunk.css";
};